import Vue from 'vue'
import App from './App.vue'
import router from "./router/index"
import vuetify from "@/plugins/vuetify";
import store from "@/store";
import Mixin from "./mixins/mixin";
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'

Vue.use(DatePicker)
Vue.config.productionTip = false
Vue.mixin(Mixin)

new Vue({
  store,
  router,
  vuetify,
  render: h => h(App),
}).$mount('#app')
